const eventsSlice = (set) => ({
  eventList: [],
  topSymptomEventCounts: [],
  eventCountLoading: null,
  loadingEvents: null,
  loadingTapTests: null,
  eventCountError: null,
  errorEvents: null,
  errorTapTests: null,
})

export default eventsSlice
